module.exports = __webpack_public_path__ + "assets/img/bmy.367802c4.png";